// extracted by mini-css-extract-plugin
module.exports = {"label":"TextField_label__1cF0u","fullWidth":"TextField_fullWidth__3PMnV"};